import styles from './FooterSimple.module.scss';
import { footerSectionTexts } from '../../utils/generalTexts';

function FooterSimple() {
  return (
    <div className={styles.footer_simple}>
      <p>{footerSectionTexts.copyright}</p>
    </div>
  );
}

export default FooterSimple;
